import axios from "axios";
import { setTokenErr } from "../Store/Common/commonStore";
import { store } from "../Store/store";
import Cookies from "js-cookie";
import { checkMaintenance } from "../Store/Maintenance/maintenanceSlice";

const DEFAULT_CONFIG = {
  headers: {
    "content-type": "application/json",
  },
};

const ENDPOINT_TIMEOUT_MESSAGE = "Endpoint request timed out";

const getResponseMessage = (response) => {
  if (typeof response === "string") {
    return response;
  }

  return response?.body?.message || response?.message || response?.data?.message || "";
};

export const isEndpointRequestTimedOut = (response) => {
  const message = getResponseMessage(response);
  return message?.toLowerCase().includes(ENDPOINT_TIMEOUT_MESSAGE.toLowerCase());
};

const setUpConfig = (isAuthenticated, token = "") => {
  if (isAuthenticated) {
    return {
      headers: {
        "content-type": "application/json",
        authorization: token ? token : Cookies.get("ssp_sso_token"),
      },
    };
  } else {
    return DEFAULT_CONFIG;
  }
};

const get = async (URL, isAuthenticated = false, getFullResult = false) => {
  try {
    const CONFIG = setUpConfig(isAuthenticated);
    const result = await axios.get(URL, CONFIG);
    if (getFullResult) {
      return result?.data?.body;
    } else {
      return result.data;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
};

const post = async (
  URL,
  PAYLOAD = {},
  isAuthenticated = false,
  getFullResult = false,
  options = {}
) => {
  try {
    store.dispatch(setTokenErr(false));
    const TOKEN = store.getState()?.common?.token;
    const CONFIG = setUpConfig(isAuthenticated, TOKEN);
    const result = await axios.post(URL, PAYLOAD, CONFIG);


    if (result?.data?.status || result?.status === 200) {
      const statusResposneInvalid = tokenExpiry(result?.data?.body?.message);
      if (!statusResposneInvalid) {
        if (getFullResult) {

          store.dispatch(checkMaintenance({ response: result.data?.body || result?.data }));
          return result.data?.body;
        } else {
          store.dispatch(checkMaintenance({ response: result?.data }))

          return result?.data;

        }
      } else {
        store.dispatch(setTokenErr(true));
        return false;
      }
    } else if (options.ignoreEndpointTimeout && isEndpointRequestTimedOut(result?.data)) {
      return result?.data;
    } else {
      store.dispatch(setTokenErr(true));
      return false;
    }
  } catch (e) {
    console.log(e);
    if (options.ignoreEndpointTimeout && (isEndpointRequestTimedOut(e?.response?.data) || e?.response?.status === 504 || e?.response?.status === 502)) {
      return e?.response?.data;
    }
    store.dispatch(setTokenErr(true));
    return false;
  }
};

export const tokenExpiry = (msg) => {
  return msg ? msg?.toLowerCase().indexOf("token") !== -1 : false;
};

export { post, get };